// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__WqTBC","footer":"ModalUpdate_footer__2qAOQ"};